export default __webpack_public_path__ + "static/verticalDots-142eecfe4ae512cbb909fb90f297bfb4.svg";